app.controller("StudentPaymentsController", ["$scope", "StaticData", "Users", "Payments", "$stateParams",
    function ($scope, StaticData, Users, Payments, $stateParams) {
        $scope.student = {};
        Users.profile($stateParams.studentId).then(function (data) {
            Payments.studentPayments(data.info.uniman.id).then(function (data) {
                $scope.payments = _.filter(data, {type: 'payment'});
                $scope.grants = _.filter(data, {type: 'grant'});
            });
            return $scope.student = data;
        });

        StaticData.getItemsByKey("grant_types").then(function (grantTypes) {
            $scope.grantTypes = grantTypes;
            $scope.grantTypesMap = _.keyBy($scope.grantTypes, '_id');
        });
    }
]);